import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		sort: {
			column: 'in_date',
			direction: 'DESC',
		},
		filters: {},
		offset: 0,
		limit: 10,
	},
	mutations: {
		set_offset(state, offset) {
			state.offset = offset;
		},
		set_limit(state, limit) {
			state.limit = limit;
		},
		set_sort(state, sort) {
			state.sort = sort;
		},
		set_filters(state, filters) {
			state.offset = 0;
			state.filters = filters;
		}
	},
	getters: {
		offset: state => {
			return state.offset;
		},
		limit: state => {
			return state.limit;
		},
		sort: state => {
			return state.sort;
		},
		filter_values: state => {
			return state.filters;
		},
		filters: state => {
			let wheres = [];
			if (state.filters.ward) {
				if (state.filters.ward === 'null') {
					wheres.push([{column: 'ward', type: 'NULL'}]);
				} else {
					wheres.push([{column: 'ward', type: '=', params: [state.filters.ward]}]);
				}
			}
			if (state.filters.notice_type) {
				wheres.push([{column: 'notice_type', type: '=', params: [state.filters.notice_type]}]);
			}

			if (state.filters.start_date) {
				wheres.push([{column: 'in_date', type: '>=', params: [state.filters.start_date]}]);
			}

			if (state.filters.end_date) {
				wheres.push([{column: 'in_date', type: '<=', params: [state.filters.end_date]}]);
			}
			if (state.filters.search_notices) {
				wheres.push([
					{column: 'description', type: 'LIKE', params: [state.filters.search_notices]},
					{column: 'address', type: 'LIKE', params: [state.filters.search_notices]},
					{column: 'notice_id', type: 'LIKE', params: [state.filters.search_notices]},
				]);
			}
			if (state.filters.upcoming_notices) {
				const now = Vue.moment().format('YYYY-MM-DD');
				wheres.push([{column: 'meeting_date', type: '>=', params: [now]}, {column: 'appeal_date', type: '>=', params: [now]}]);
			}

			return wheres;
		},
	},
	actions: {
	},
	modules: {
	}
})
